// src/data/mockDocuments.ts
import { DocumentData } from "../types/Document.ts";

export const mockDocuments: DocumentData[] = [
  {
    id: 1,
    title: "提案書（サンプル）",
    content:
      "これはAIで生成した提案書のサンプルコンテンツです。\n課題: 現状の営業プロセスには時間がかかっています...\n提案: 新しい自動化ソリューションを導入することで..."
  },
  {
    id: 2,
    title: "FAQリスト（サンプル）",
    content:
      "Q: このサービスは何を提供しますか？\nA: AIを用いたドキュメント生成を提供します。\nQ: 利用開始方法は？\nA: ..."
  }
];
